import React from 'react'
import { usePerson } from 'contexts/person'
import { useGetNavigationItems } from 'pages/people/pages/profile/utilities'
import { ContainerQuery, Wrapper, Side, Navigation, Main } from './about/s'
import Salary from 'pages/people/pages/profile/panes/about/salary'
import Employment from 'pages/people/pages/profile/panes/about/employment'
import Financial from 'pages/people/pages/profile/panes/about/financial'

const SalaryPane = ({ lookingAtMyOwnProfile, standalone = true, layout, salt }) => {
    const { person } = usePerson()

    const navigationItems = useGetNavigationItems(person, lookingAtMyOwnProfile, navigationSections)

    const getSectionProps = pepper => ({
        lookingAtMyOwnProfile,
        standalone,
        layout,
        salt: `${salt}:${pepper}`
    })

    return (
        <ContainerQuery>
            <Wrapper>
                <Main>
                    <Salary
                        {...getSectionProps('salary')}
                        userId={lookingAtMyOwnProfile ? 'me' : person.id} />
                    <Employment {...getSectionProps('employment')} />
                    <Financial {...getSectionProps('financial')} />
                </Main>
                <Side>
                    <Navigation
                        navigationItems={navigationItems}
                        salt={salt} />
                </Side>
            </Wrapper>
        </ContainerQuery>
    )
}

const navigationSections = [
    {
        id: 'salary',
        fields: ['salary']
    },
    {
        id: 'employment',
        fields: [
            'jobTitle',
            'jobDescription',
            'employmentType',
            'employmentPercentage',
            'employmentStartDate',
            'firstDayOfWork',
            'employmentEndDate',
            'lastDayOfWork',
            'employmentId'
        ]
    },
    {
        id: 'financial',
        fields: ['bankAccount']
    }
]

export default SalaryPane